export default {
  methods: {
    /**
     * Formatta un numero come valuta europea con simbolo dell'euro
     * @param {number|string} value - Il valore da formattare
     * @param {number} decimals - Numero di decimali (default: 2)
     * @returns {string} - Valore formattato come valuta
     */
    formatCurrency(value, decimals = 2) {
      // Controlla se il valore è null, undefined o stringa vuota
      if (value === null || value === undefined || value === '') {
        value = 0;
      }

      // Converte in numero se è una stringa
      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      
      // Controlla se è un numero valido
      if (isNaN(numValue)) {
        value = 0;
      }

      // Formatta il numero con separatori europei
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(numValue);
    },

    /**
     * Formatta un numero come valuta senza simbolo (solo il numero formattato)
     * @param {number|string} value - Il valore da formattare
     * @param {number} decimals - Numero di decimali (default: 2)
     * @returns {string} - Valore formattato senza simbolo di valuta
     */
    formatNumber(value, decimals = 2) {
      if (value === null || value === undefined || value === '') {
        return '0.00';
      }

      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      
      if (isNaN(numValue)) {
        return '0.00';
      }

      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: false
      }).format(numValue);
    },

    /**
     * Formatta un numero per la sola visualizzazione, con separatore delle migliaia
     * in stile italiano (es. 1.234.567,89). Non usare per valori che verranno poi
     * riparsati come numero.
     * @param {number|string} value - Il valore da formattare
     * @param {number} decimals - Numero di decimali (default: 2)
     * @returns {string} - Valore formattato per visualizzazione
     */
    formatNumberDisplay(value, decimals = 2, useGrouping = true) {
      if (value === null || value === undefined || value === '') {
        value = 0;
      }

      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      const safeValue = isNaN(numValue) ? 0 : numValue;

      return new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: !!useGrouping
      }).format(safeValue);
    },

    formatNumberForInput(value, decimals = 2, useGrouping = true) {
      if (value === null || value === undefined || value === '') {
        return '';
      }

      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      
      if (isNaN(numValue)) {
        return '';
      }

      return new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: !!useGrouping
      }).format(numValue);
    },

    parseNumberFromInput(displayValue, decimals = 2) {
      if (!displayValue || displayValue === '') {
        return null;
      }

      const str = String(displayValue)
        .replace(/\./g, '')
        .replace(',', '.');
      
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    }
  }
};
